export const ruTranslations = {
  // Navigation
  customerIntake: "Прием клиентов",
  customerHistory: "История клиентов",
  labelGeneration: "Создание этикеток",
  diagnosticEntry: "Диагностика",
  accounting: "Бухгалтерия",
  completion: "Завершение",
  dailyCashRegister: "Ежедневная касса",

  // Settings
  settingsTitle: "Настройки",
  settingsUpdated: "Настройки успешно обновлены",
  smsNotificationsTitle: "SMS уведомления",
  smsNotificationsToggleTitle: "Отправка SMS уведомлений",
  smsNotificationsToggleDesc: "Если отключено, SMS не будут отправляться ни при каких условиях",
  smsNotificationsEnabledHint: "✓ SMS уведомления включены. Клиенты будут получать автоматические сообщения.",
  smsNotificationsDisabledHint: "⚠ SMS уведомления отключены. SMS отправляться не будут.",
  priceFieldTitle: "Поле цены",
  priceFieldToggleTitle: "Скрыть поле цены",
  priceFieldToggleDesc: "Если включено, поле цены будет скрыто на экране приема клиента",
  priceFieldHiddenHint: "✓ Поле цены скрыто. Пользователь может нажать “Показать”, чтобы увидеть его.",
  priceFieldVisibleHint: "✓ Поле цены отображается. Оно будет видно автоматически на экране приема клиента.",

  // Feedback
  feedbackTitle: "Предложения и запросы",
  feedbackDesc: "Отправьте идею, сообщение об ошибке или запрос на новую функцию. Мы получим это в Telegram.",
  feedbackAltContact: "Или отправьте предложение по pMaster в Telegram:",
  feedbackSubmitted: "Спасибо! Ваше сообщение отправлено.",
  feedbackSubmitFailed: "Не удалось отправить. Пожалуйста, попробуйте еще раз.",
  feedbackMessageRequired: "Введите текст сообщения",
  feedbackTypeLabel: "Тип",
  feedbackTypeSuggestion: "Предложение",
  feedbackTypeBug: "Ошибка",
  feedbackTypeRequest: "Запрос",
  feedbackTypeOther: "Другое",
  feedbackContactLabel: "Контакт (необязательно)",
  feedbackContactPlaceholder: "Телефон, Telegram username, email",
  feedbackMessageLabel: "Сообщение",
  feedbackMessagePlaceholder: "Опишите идею или проблему...",
  feedbackRateLimitHint: "Лимит: 3 сообщения в час",

  // Telegram Reports
  telegramReportsTitle: "Telegram отчеты",
  telegramReportsDesc: "Получайте ежедневные бизнес-отчеты через Telegram бота. Свяжите свой аккаунт, чтобы начать.",
  telegramLinkButton: "Связать Telegram",
  telegramUnlinkButton: "Отвязать",
  telegramLinkedStatus: "Telegram аккаунт связан",
  telegramNotLinkedStatus: "Telegram аккаунт не связан",
  telegramLinkedAt: "Связан",
  telegramLinking: "Связывание...",
  telegramLinkInstructions: "Бот открыт. Пожалуйста, запустите бота в Telegram, чтобы завершить связывание.",
  telegramLinkSuccess: "Аккаунт успешно связан!",
  telegramLinkFailed: "Ошибка при связывании. Пожалуйста, попробуйте еще раз.",
  telegramUpdateFailed: "Ошибка при обновлении настроек",
  telegramReportTimeLabel: "Время отчета (Ташкент)",
  telegramReportTimeHint: "Ежедневные отчеты будут отправляться в это время",
  telegramReportEnabledLabel: "Включить ежедневные отчеты",
  telegramReportEnabledDesc: "Получайте ежедневную бизнес-статистику через Telegram",
  telegramReportEnabledHint: "✓ Ежедневные отчеты включены. Отчеты будут отправляться в выбранное время.",
  telegramReportDisabledHint: "Ежедневные отчеты отключены. Включите, чтобы получать отчеты.",
  telegramTestButton: "Отправить тестовый отчет",
  telegramTestSending: "Отправка...",
  telegramTestFailed: "Ошибка отправки тестового отчета",

  // Data Export
  dataExportTitle: "Экспорт данных",
  dataExportDesc: "Экспортируйте все ваши бизнес-данные в виде ZIP-архива (файлы XLSX и резервная копия JSON). Стоимость: 5,000 UZS за экспорт.",
  googleDriveConnected: "Google Drive подключен",
  googleDriveNotConnected: "Google Drive не подключен",
  googleDriveConnectedDesc: "Экспорты будут автоматически загружены в ваш Google Drive",
  googleDriveNotConnectedDesc: "Подключите Google Drive для автоматической загрузки экспортов",
  googleDriveConnectButton: "Подключить Google Drive",
  googleDriveConnecting: "Подключение...",
  googleDriveDisconnectButton: "Отключить Google Drive",
  googleDriveError: "Ошибка подключения Google Drive",
  googleDriveConnectError: "Ошибка подключения Google Drive",
  googleDriveDisconnectError: "Ошибка отключения Google Drive",
  exportCost: "Стоимость экспорта",
  insufficientBalanceExport: "Недостаточно средств. Текущий баланс: {{balance}} UZS",
  currentBalanceExport: "Текущий баланс: {{balance}} UZS",
  exporting: "Экспорт...",
  exportDownload: "Скачать экспорт",
  exportToDrive: "Экспортировать в Google Drive",
  exportError: "Ошибка экспорта",
  exportHistory: "Последние экспорты",
  toGoogleDrive: "В Google Drive",
  view: "Просмотр",

  // Common
  loading: "Загрузка...",
  save: "Сохранить",
  cancel: "Отмена",
  submit: "Отправить",
  search: "Поиск",
  edit: "Редактировать",
  delete: "Удалить",
  back: "Назад",
  next: "Далее",
  previous: "Предыдущий",
  close: "Закрыть",
  open: "Открыть",
  yes: "Да",
  no: "Нет",
  ok: "ОК",
  error: "Ошибка",
  success: "Успех",
  warning: "Предупреждение",
  info: "Информация",

  // Auth
  signIn: "Войти",
  signOut: "Выйти",
  signUp: "Регистрация",
  signInWithGoogle: "Войти через Google",
  continueWithGoogle: "Продолжить с Google",
  email: "Email",
  password: "Пароль",
  confirmPassword: "Подтвердите пароль",
  forgotPassword: "Забыли пароль?",
  resetPassword: "Сбросить пароль",
  resetPasswordTitle: "Сброс пароля",
  resetPasswordDesc: "Введите новый пароль ниже",
  newPassword: "Новый пароль",
  confirmNewPassword: "Подтвердите новый пароль",
  passwordResetSuccess: "Пароль успешно сброшен! Теперь вы можете войти с новым паролем.",
  passwordResetError: "Не удалось сбросить пароль. Попробуйте еще раз.",
  sendResetEmail: "Отправить письмо для сброса",
  resetEmailSent: "Письмо для сброса пароля отправлено! Проверьте почту.",
  resetEmailError: "Не удалось отправить письмо. Попробуйте еще раз.",
  rememberMe: "Запомнить меня",
  createAccount: "Создать аккаунт",
  alreadyHaveAccount: "Уже есть аккаунт?",
  dontHaveAccount: "Нет аккаунта?",
  signingIn: "Вход...",
  creatingAccount: "Создание аккаунта...",

  // Business Setup
  setupBusiness: "Настройка бизнеса",
  setupBusinessDesc: "Введите информацию о вашем бизнесе",
  businessName: "Название бизнеса",
  businessNamePlaceholder: "Например: Tech Repair Service",
  location: "Адрес",
  locationPlaceholder: "Например: Ташкент, Узбекистан",
  saveBusiness: "Сохранить бизнес",
  saving: "Сохранение...",

  // Customer Intake
  customerInformation: "Информация о клиенте",
  customerName: "Имя клиента",
  phoneNumber: "Номер телефона",
  searchOrEnterNewName: "Найти или ввести новое имя",
  searchOrEnterNewNumber: "Найти или ввести новый номер",
  deviceInformation: "Информация об устройстве",
  deviceType: "Тип устройства",
  deviceModel: "Модель устройства",
  issueDescription: "Описание проблемы",
  submitAndGenerateLabel: "Отправить и создать этикетку",
  submitting: "Отправка...",

  // Device Types
  laptop: "Ноутбук",
  printer: "Принтер",
  monitor: "Монитор",
  other: "Другое",

  // Form Validation
  nameRequired: "Имя обязательно",
  phoneRequired: "Номер телефона обязателен",
  invalidPhone: "Неверный номер телефона. Введите узбекский номер.",
  phoneIncomplete: "Номер телефона неполный",
  deviceTypeRequired: "Необходимо выбрать тип устройства",
  deviceModelRequired: "Необходимо указать модель устройства",
  serialNumberRequired: "Необходимо указать серийный номер",
  issueDescriptionRequired: "Необходимо описать проблему",

  // Status
  accepted: "Принято",
  diagnosed: "Диагностировано",
  fixed: "Готово",
  picked: "Забрано",
  cancelled: "Отменено",

  // Financial
  income: "Доход",
  expenses: "Расходы",
  balance: "Баланс",
  amount: "Сумма",
  total: "Итого",
  paid: "Оплачено",
  due: "К оплате",
  price: "Цена",
  estimatedCost: "Ориентировочная стоимость",
  showPriceField: "Показать поле цены",
  hidePriceField: "Скрыть поле цены",
  paymentMethod: "Способ оплаты",
  creditCard: "Кредитная карта",
  debitCard: "Дебетовая карта",
  cash: "Наличные",
  bankTransfer: "Банковский перевод",

  // Time periods
  today: "Сегодня",
  yesterday: "Вчера",
  thisWeek: "На этой неделе",
  thisMonth: "В этом месяце",
  date: "Дата",
  time: "Время",

  // Landing page
  heroTitle: "Ремонт компьютеров, принтеров, Macbook, бытовой техники и других устройств",
  proMasters: "Про Мастера",
  forCRM: "система управления",
  heroDescription: "Ремонт компьютеров, принтеров, Macbook, бытовой техники и других устройств",
  getStartedFree: "Начать бесплатно",
  viewFeatures: "Посмотреть возможности",
  powerfulFeatures: "Мощные возможности",
  choosePlan: "Выберите план",
  freePlan: "Бесплатный план",
  premiumPlan: "Премиум план",
  businessPlan: "Бизнес план",
  corporatePlan: "Корпоративный",
  corporatePlanDesc: "Для крупных организаций с несколькими филиалами, индивидуальными интеграциями и выделенной поддержкой",
  forever: "Навсегда",
  perMonth: "в месяц",
  custom: "Индивидуально",
  contactUs: "Свяжитесь с нами",
  popular: "Популярный",
  upTo10Customers: "До 10 клиентов",
  upTo10Repairs: "До 10 ремонтов",
  freePlanDesc: "Основные функции для небольших мастерских",
  premiumPlanDesc: "Все функции без ограничений — для профессиональных мастерских",
  upTo100Customers: "До 100 клиентов",
  upTo20Repairs: "До 20 ремонтов",
  upTo100Repairs: "До 100 ремонтов",
  upTo300Repairs: "До 300 ремонтов",
  unlimitedRepairs: "Неограниченные ремонты",
  unlimitedCustomers: "Неограниченные клиенты",
  unlimitedEverything: "Без ограничений",
  multiLocationSupport: "Поддержка нескольких филиалов",
  advancedAnalytics: "Расширенная аналитика и отчеты",
  customIntegrations: "Индивидуальные интеграции",
  dedicatedSupport: "Выделенная команда поддержки",
  customBranding: "Индивидуальный брендинг",
  apiAccess: "Доступ к API",
  priorityUpdates: "Приоритетная поддержка",
  startManaging: "Начните профессионально управлять своим ремонтным бизнесом",
  basicRepairTracking: "Базовое отслеживание ремонтов",
  qrCodeLabels: "QR-код этикетки",
  excelReports: "Excel отчеты",
  contactSales: "Связаться с отделом продаж",
  tryForFree: "Попробовать бесплатно",

  // Problems section
  problemsWesolve: "Проблемы, которые мы решаем",
  problemsSubtitle: "Типичные проблемы мастеров по ремонту",
  cashTrackingProblem: "Отслеживание денежных средств",
  cashTrackingDesc: "Невозможность отслеживать ежедневные доходы и расходы из кассы, что приводит к финансовой путанице и потерям.",
  customerManagementProblem: "Управление клиентами и ремонтами",
  customerManagementDesc: "Сложность управления информацией о клиентах и отслеживания нескольких ремонтов одновременно, что приводит к срыву сроков.",
  smsNotificationProblem: "Общение с клиентами",
  smsNotificationDesc: "Трата времени на звонки клиентам о статусе ремонта вместо работы, что снижает производительность.",
  paperworkProblem: "Бумажные записи",
  paperworkDesc: "Потеря информации о ремонте, данных клиентов или гарантийных документов из-за неорганизованных бумажных записей.",
  deviceConditionProblem: "Документация состояния устройства",
  deviceConditionDesc: "Отсутствие записи о состоянии устройства и существующих проблемах при приеме, что приводит к спорам и отказу клиентов принять ответственность.",

  // Features section
  customerSelfService: "Отслеживание статуса для клиентов",
  customerSelfServiceDesc: "Клиенты могут самостоятельно проверить статус через QR-код, звонки не нужны",
  qrCodeStatusCheck: "Проверка статуса через QR-код",
  publicShopPage: "Публичная страница магазина",
  realTimeUpdates: "Обновления в реальном времени",
  
  pickupFromHome: "Забор из дома",
  pickupFromHomeDesc: "Сервис забора по требованию - клиенты могут запросить забор устройства из дома",
  onDemandPickup: "Сервис забора по требованию",
  realTimeTracking: "Отслеживание в реальном времени",
  deliveryIntegration: "Интеграция с логистическими платформами",
  
  platformIntegrations: "Интеграции платформ",
  platformIntegrationsDesc: "Интеграция со всеми необходимыми инструментами - платежи, учет, электронная коммерция",
  paymentIntegrations: "Платежные интеграции",
  accountingIntegrations: "Удаленная консультация",
  ecommerceIntegrations: "Платформы электронной коммерции",
  
  automaticNotifications: "Автоматические уведомления",
  automaticNotificationsDesc: "Автоматические SMS и информационные звонки - нет необходимости звонить клиентам вручную",
  smsNotifications: "SMS уведомления",
  informingCalls: "Информационные звонки",
  workflowBased: "Удаленная диагностика",
  
  scalableTechStack: "Масштабируемый технологический стек",
  scalableTechStackDesc: "Современный технологический стек, готовность к мультитенантности, API-first подход, облачная архитектура",
  modernArchitecture: "Современная архитектура",
  multiTenantReady: "Готовность к мультитенантности",
  apiFirst: "API-first подход",

  // Common phrases
  backToHome: "Вернуться на главную",
  contactSupport: "Связаться с поддержкой",
  allRightsReserved: "Все права защищены",
  dashboard: "Панель управления",

  // CTA section
  startStreamlining: "Начните оптимизацию",
  joinRepairShops: "Присоединяйтесь к тысячам ремонтных мастерских",

  // Stats section
  lessAdminWork: "Меньше административной работы",
  digitalTracking: "Цифровое отслеживание",
  statusTracking: "Отслеживание статуса",

  // Sign in page specific
  signInDesc: "Войдите в свой аккаунт",
  signUpForFree: "Зарегистрироваться бесплатно",
  signInInstead: "Войти вместо этого",
  noCardRequired: "Карта не требуется",
  premiumPaymentNote: "При выборе премиум плана потребуется оплата",
  agreeToTerms: "Вы соглашаетесь с",
  and: "и",

  // Footer
  quickLinks: "Быстрые ссылки",
  legal: "Правовая информация",
  termsOfService: "Условия использования",
  privacyPolicy: "Политика конфиденциальности",
  
  // Additional missing translations
  devicePhotos: "Фотографии устройства",
  addPhoto: "Добавить фото",
  devicePhotoNum: "Фото устройства {{num}}",
  photoUploadInfo: "JPEG, PNG или WebP формат, максимум 5МБ. До 4 фотографий.",
  unsupportedImageType: "Файл {{name}} не поддерживается",
  fileTooLarge: "Файл {{name}} слишком большой (максимум 5МБ)",
  maxPhotosReached: "Можно добавить максимум 4 фотографии",
  
  // Search and filters
  searchCustomers: "Поиск клиентов",
  searchRepairs: "Поиск ремонтов",
  searchTransactions: "Поиск транзакций",
  searchByCustomer: "Поиск по клиенту",
  searchByRepairID: "Поиск по ID ремонта",
  searchCustomerName: "Поиск имени клиента",
  searchRepairID: "Поиск ID ремонта",
  searchByRepairIdCustomerNamePhoneDeviceModel: "Поиск по ID ремонта, имени клиента, номеру телефона или модели устройства",
  
  // Repair status and details
  repairID: "ID ремонта",
  customer: "Клиент",
  device: "Устройство",
  issue: "Проблема",
  status: "Статус",
  createdAt: "Создано",
  
  // Label generation
  labelPreview: "Предварительный просмотр этикетки",
  repairDetails: "Детали ремонта",
  downloadLabel: "Печать этикетки",
  generatingLabel: "Создание этикетки...",
  backToCustomerIntake: "Вернуться к приему клиентов",
  newRepair: "Новый ремонт",
  latestRepairs: "Последние ремонты",
  searchResults: "Результаты поиска",
  noRepairsFound: "Ремонты не найдены",
  noRecentRepairs: "Нет недавних ремонтов",
  
  // Diagnostic
  selectRepair: "Выберите ремонт",
  diagnosticDetails: "Детали диагностики",
  reportedIssue: "Заявленная проблема",
  estimatedTime: "Ориентировочное время",
  requiredParts: "Необходимые детали",
  diagnosticNotes: "Заметки диагностики",
  partNumbersPlaceholder: "Номера деталей или описание",
  enterDiagnosticFindings: "Введите результаты диагностики",
  completeDiagnostic: "Завершить диагностику",
  completing: "Завершение...",
  noPendingRepairs: "Нет ожидающих ремонтов",
  invalidTime: "Неверное время",
  invalidCost: "Неверная стоимость",
  notesRequired: "Заметки обязательны",
  
  // Accounting
  servicedAmount: "Сумма обслуживания",
  paidAmount: "Оплаченная сумма",
  balanceDue: "Остаток к доплате",
  paymentDetails: "Детали платежа",
  paymentAmount: "Сумма платежа",
  enterAmount: "Введите сумму",
  paymentNotes: "Заметки к платежу",
  addPaymentNotes: "Добавить заметки к платежу",
  recordPayment: "Записать платеж",
  recording: "Запись...",
  selectRepairPayment: "Выберите ремонт для оплаты",
  noRepairsWithPayments: "Нет ремонтов с платежами",
  
  // Completion
  completionChecklist: "Чек-лист завершения",
  repairsCompleted: "Ремонт завершен",
  qualityAssurance: "Контроль качества",
  deviceCleaned: "Устройство очищено",
  finalInspection: "Финальная проверка",
  completionNotes: "Заметки о завершении",
  enterCompletionNotes: "Введите заметки о завершении",
  customerNotification: "Уведомление клиента",
  repairCompletedMessage: "Ваше устройство отремонтировано и готово к получению. Общая сумма: ${{amount}}",
  markNotificationSent: "Отметить уведомление как отправленное",
  completeRepair: "Завершить ремонт",
  cancelRepair: "Отменить ремонт",
  cancelling: "Отмена...",
  confirmCancellation: "Подтвердить отмену",
  cancelRepairWarning: "Этот ремонт будет отменен. Введённые вами заметки будут сохранены как причина отмены.",
  keepRepair: "Сохранить ремонт",
  confirmCancel: "Подтвердить отмену",
  noRepairsForCompletion: "Нет ремонтов для завершения",
  selectRepairToComplete: "Выберите ремонт для завершения",
  cancelDiagnosticTitle: "Отменить диагностику",
  cancelDiagnosticWarning: "Вы уверены, что хотите отменить этот ремонт? Введенные диагностические заметки будут сохранены как причина отмены.",
  cancelDiagnosticKeep: "Нет, продолжить",
  cancelDiagnosticConfirm: "Да, отменить ремонт",
  repairTimeline: "История ремонта",
  currentStatusDate: "Текущий статус",
  acceptedOn: "Принято",
  diagnosedOn: "Диагностировано",
  fixedOn: "Готово",
  pickedOn: "Забрано",
  cancelledOn: "Отменено",
  
  // Services
  providedServices: "Предоставленные услуги",
  addService: "Добавить услугу",
  quickAddServices: "Быстрое добавление",
  serviceName: "Название услуги",
  totalServiceCost: "Общая стоимость услуг",
  noServicesAdded: "Услуги не добавлены",
  addServicesDescription: "Добавьте выполненные услуги и их стоимость",

  // Daily Cash
  addTransaction: "Добавить транзакцию",
  type: "Тип",
  description: "Описание",
  enterDescription: "Введите описание",
  period: "Период",
  noTransactionsFound: "Транзакции не найдены",
  invalidAmount: "Неверная сумма",
  incomeTypeRequired: "Необходимо выбрать тип дохода",
  customIncomeTypeRequired: "Введите тип дохода",
  expenseTypeRequired: "Необходимо выбрать тип расхода",
  customExpenseTypeRequired: "Введите тип расхода",
  expense: "Расход",
  
  // Customer History
  customerSince: "Клиент с",
  showFilters: "Показать фильтры",
  hideFilters: "Скрыть фильтры",
  resetFilters: "Сбросить фильтры",
  startDate: "Дата начала",
  endDate: "Дата окончания",
  repairStatus: "Статус ремонта",
  diagnosticStatus: "Статус диагностики",
  all: "Все",
  filterAll: "Все статусы",
  filterDiagnosed: "В ремонте",
  filterCompleted: "Завершено",
  withDiagnostic: "С диагностикой",
  withoutDiagnostic: "Без диагностики",
  repairHistory: "История ремонтов",
  showingRepairs: "Показано {{shown}} из {{total}} ремонтов",
  noRepairsMatch: "Ни один ремонт не соответствует критериям",
  none: "Нет",

  // Additional form translations
  
  // Payme payment
  topupBalance: "Пополнить баланс",
  currentBalance: "Текущий баланс",
  topupAmount: "Сумма пополнения (UZS)",
  minAmount: "Минимальная сумма: 1,000 UZS",
  payWithPayme: "Оплатить через Payme",
  processingPayment: "Обработка платежа...",
  paymentRedirecting: "Перенаправление на страницу оплаты Payme...",
  paymentSuccess: "Платеж успешно выполнен! Баланс пополнен.",
  paymentFailed: "Ошибка при обработке платежа. Пожалуйста, попробуйте еще раз.",
  paymentCancelled: "Платеж отменен.",
  paymentPending: "Ожидание платежа...",
  invalidAmountError: "Пожалуйста, введите правильную сумму",
  paymeNotConfigured: "Ошибка настройки Payme. Пожалуйста, свяжитесь с администратором.",
  
  // Click payment
  payWithClick: "Оплатить через Click",
  clickNotConfigured: "Ошибка настройки Click. Пожалуйста, свяжитесь с администратором.",
  clickPaymentRedirecting: "Перенаправление на страницу оплаты Click...",
  selectPaymentMethod: "Выберите способ оплаты",
  
  // PDF warnings
  cyrillicWarning: "Примечание: Кириллические символы могут отображаться некорректно в PDF. Пожалуйста, используйте латиницу или узбекский алфавит.",
  
  // Balance History
  smsPriceWarning: "Отправленные сообщения могут иметь разную стоимость в зависимости от того, какому оператору принадлежит номер телефона получателя",

  // Plan Limits
  planLimitReached: "Лимит бесплатного плана исчерпан",
  planLimitReachedDesc: "Вы использовали все {{max}} ремонтов бесплатного плана. Перейдите на Premium для продолжения.",
  planLimitWarning: "Бесплатные ремонты заканчиваются",
  planLimitWarningDesc: "У вас осталось {{remaining}} из {{max}} бесплатных ремонтов. Перейдите на Premium для большего.",
  upgradeToPremium: "Перейти на Premium",
  premiumTrialActive: "Пробный период Premium",
  premiumTrialDesc: "У вас осталось {{remaining}} из {{total}} бесплатных пробных ремонтов. После этого потребуется подписка.",
  repairsUsed: "ремонтов использовано",

  // Subscription
  subscriptionTitle: "Подписка",
  currentPlan: "Текущий тариф",
  planExpiresOn: "Срок действия: {{date}}",
  daysLeft: "дней осталось",
  subscribeToPremium: "Подписаться на Premium",
  renewSubscription: "Продлить подписку",
  subscriptionCost: "Стоимость подписки",
  confirmSubscription: "С баланса будет списано {{amount}} UZS. Подтверждаете?",
  subscriptionSuccess: "Подписка успешно активирована!",
  subscriptionFailed: "Ошибка при активации подписки",
  insufficientBalanceSubscription: "Недостаточно средств на балансе. Пожалуйста, пополните баланс.",
  subscriptionExpired: "Срок подписки истёк",
  subscriptionExpiredDesc: "Срок действия Premium подписки истёк. Продлите подписку для продолжения.",
  subscriptionHistory: "История подписок",
  subscriptionUpgrade: "Переход на Premium",
  subscriptionRenewal: "Продление подписки",
  subscriptionDowngrade: "Возврат на бесплатный",
  subscriptionExpiredAction: "Срок истёк",

  // Auto-renewal
  autoRenew: "Автопродление",
  autoRenewDesc: "Автоматическое списание с баланса при истечении подписки",
  autoRenewInsufficientBalance: "Недостаточно средств — автопродление может не сработать",

  // Blog
  blogTitle: "Блог",
  blogDescription: "Полезные статьи и руководства для мастерских по ремонту",
  readMore: "Читать далее",
  publishedOn: "Опубликовано",
  backToBlog: "Вернуться в блог",

  // Testimonials
  testimonialsTitle: "Отзывы пользователей",
  testimonialsSubtitle: "Мастерские по всему Узбекистану работают с pMaster",
  reviews: "отзывов",

  // Photo source
  photoSourceTitle: "Добавить фото",
  photoSourceCamera: "Камера",
  photoSourceGallery: "Галерея",
  photoSourceCancel: "Отмена",
  cameraPermissionDenied: "Доступ к камере запрещён. Разрешите доступ в настройках.",
  cameraNotFound: "Камера не найдена на этом устройстве.",
  cameraError: "Не удалось запустить камеру.",
  tryAgain: "Попробовать снова",

  // Referral
  referralTitle: "Реферальная программа",
  referralCode: "Реферальный код",
  referralCopied: "Скопировано!",
  referralShare: "Поделиться",
  copyLink: "Копировать ссылку",
  referralTotalInvited: "Приглашено",
  referralCompleted: "Бонус получен",
  referralTotalBonus: "Всего бонусов",
  referralCodeInput: "Реферальный код (необязательно)",
  referralInvalidCode: "Неверный реферальный код",
  referralSelfReferral: "Нельзя использовать свой код",
  referralAlreadyReferred: "Вы уже были приглашены",
  referralBonusInfo: "Бонус 50 000 UZS будет начислен, когда ваш реферал создаст первый ремонт",

  // Landing Page - Problems Section
  problems_label: "ПРОБЛЕМЫ",
  problems_title: "Без правильных инструментов мастерская — это хаос",
  problems_desc: "От потока денег до записей клиентов — эти 4 проблемы наносят ущерб каждый день",
  p1_title: "Путаница с денежным потоком",
  p1_desc: "Без отслеживания дневного дохода и расходов вы теряете контроль над финансами и деньги исчезают.",
  p1_fix: "Цифровая касса с ежедневными PDF-отчетами",
  p2_title: "Потерянные записи клиентов",
  p2_desc: "Управление информацией о клиентах и отслеживание нескольких ремонтов одновременно сложно, что приводит к пропущенным срокам.",
  p2_fix: "Поддерживаемая поиском база данных клиентов",
  p3_title: "Бесконечные телефонные звонки",
  p3_desc: "Клиенты звонят каждый день и спрашивают 'готово ли?' Это тратит ваше время и расстраивает обе стороны.",
  p3_fix: "Автоматические SMS + публичная страница статуса",
  p4_title: "Споры о состоянии устройства",
  p4_desc: "Без документирования состояния устройства при получении, клиенты оспаривают, что было не так, вызывая конфликты.",
  p4_fix: "Фотодокументирование при приеме",

  // Landing Page - Features Section
  features_label: "ВОЗМОЖНОСТИ",
  features_title: "Все необходимое для управления современной мастерской",
  features_desc: "Полный набор инструментов для упрощения работы и улучшения обслуживания клиентов.",
  f1_title: "Приём и отслеживание клиентов",
  f1_desc: "Простая форма приема клиентов, управление услугами ремонта и отслеживание статуса в режиме реального времени.",
  f2_title: "QR-коды для ремонтных наклеек",
  f2_desc: "Генерируйте уникальные QR-коды для каждого ремонта. Клиенты сканируют, чтобы проверить статус в любое время.",
  f3_title: "Автоматические SMS-уведомления",
  f3_desc: "Отправляйте автоматические SMS: получено, диагностика готова, ремонт завершен — без ручной работы.",
  f4_title: "Ежедневная касса",
  f4_desc: "Отслеживайте дневной доход — наличные, Payme, Click. Автоматически генерируйте ежедневные PDF-отчеты.",
  f5_title: "Публичная страница статуса",
  f5_desc: "Клиенты сами проверяют статус ремонта через QR или ссылку. Никаких телефонных звонков не требуется.",
  f6_title: "Ежедневные отчёты в Telegram",
  f6_desc: "Получайте ежедневную статистику бизнеса в Telegram: завершенные ремонты, доход, количество клиентов.",

  // CTA Section
  cta_title: "Готовы управлять вашей мастерской как профессионал?",
  cta_desc: "Присоединитесь к 2500+ владельцам мастерских, которые уже используют pMaster...",
  cta_btn: "Начать бесплатно",

  // Footer
  footer_desc: "pMaster - CRM для ремонтных мастерских, разработанный для рынка Узбекистана. Упростите операции и развивайте бизнес.",
  footer_product: "Продукт",
  footer_blog: "Блог",
  footer_company: "Компания",
  footer_about: "О нас",
  footer_privacy: "Политика конфиденциальности",
  footer_terms: "Условия использования",
  footer_contact: "Контакты",
  footer_made: "Создано с заботой для владельцев мастерских по всему миру",

  // How It Works Section
  how_label: "ПРОЦЕСС",
  how_title: "Как это работает?",
  how_desc: "Преобразуйте вашу мастерскую за 3 простых шага",
  s1_title: "Прием клиента",
  s1_desc: "Заполните форму приема, фотографируйте устройство и описите проблему.",
  s2_title: "Диагностика и оплата",
  s2_desc: "Введите результаты диагностики, установите цену и отправьте SMS клиенту.",
  s3_title: "Завершение и анализ",
  s3_desc: "Завершите ремонт, получите ежедневный отчет в PDF или Telegram.",

  // Device Types Section
  devices_label: "УСТРОЙСТВА",
  devices_title: "Любое устройство - мы справимся",
  devices_desc: "pMaster может управлять ремонтом любого типа электроники и бытовой техники",

  // FAQ Section
  faq_label: "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ",
  faq_title: "Ответы на вопросы",
  q1: "pMaster бесплатен?",
  a1: "Да, pMaster предлагает бесплатный план с базовыми функциями. Премиум планы доступны с дополнительными возможностями.",
  q2: "Мои данные будут в безопасности?",
  a2: "Да, все данные зашифрованы и безопасно хранятся на Supabase. Мы соблюдаем требования GDPR и законодательство Узбекистана.",
  q3: "Какие платежи я могу принимать?",
  a3: "pMaster интегрирован с Click и Payme - самые популярные платежные системы в Узбекистане.",
  q4: "Есть ли мобильное приложение?",
  a4: "Да, pMaster работает как PWA (Progressive Web App). Вы можете использовать его прямо в мобильном браузере.",
  q5: "Есть ли поддержка?",
  a5: "Да, мы поддерживаем вас 24/7 через Telegram и email. Предлагайте новые функции - мы их добавим.",
  q6: "Могу ли я перейти на другого провайдера?",
  a6: "Конечно! Вы можете экспортировать все данные в CSV/XLSX.",
  q7: "Доступно ли на других языках?",
  a7: "Да, pMaster доступен на узбекском, русском и английском языках. Вы можете изменить язык в настройках.",
  q8: "Что делает бот в Telegram?",
  a8: "Telegram бот отправляет ежедневные отчеты, уведомления о клиентах и статистику.",

  // Header & Nav
  nav_features: "Функции",
  nav_how: "Как это работает",
  nav_pricing: "Цены",
  nav_faq: "Вопросы",
  header_cta: "Начать бесплатно",

  // Hero
  hero_title: "Лучший способ управлять ремонтной мастерской",
  hero_sub: "Бесплатная облачная CRM для ремонтных мастерских. Отслеживайте заказы, уведомляйте клиентов автоматически и управляйте финансами — с любого устройства.",
  hero_cta: "Начать бесплатно",
  hero_learn: "Узнать больше",
  badge_free: "Бесплатный план навсегда",
  badge_nocard: "Без банковской карты",
  badge_pwa: "Работает на любом устройстве",

  // Hero floating cards
  card_sms: "SMS отправлено",
  card_sent: "Клиент уведомлён",
  card_qr: "QR сканирован",
  card_scanned: "Статус проверен",
  card_today: "Сегодня",
  card_income: "1 250 000 сум",
  card_daily: "Дневной доход",

  // Stats
  stat_shops_label: "Мастерских",
  stat_repairs_label: "Ремонтов",
  stat_rating_label: "Рейтинг",
  stat_uptime_label: "Аптайм",

  // CTA
  cta_desc: "Присоединяйтесь к 2 500+ владельцам мастерских. Бесплатно, настройка за 5 минут.",
  cta_btn: "Создать бесплатный аккаунт",

  // Footer
  footer_product: "Продукт",
  footer_blog: "Блог",
  footer_company: "Компания",
  footer_about: "О нас",
  footer_contact: "Контакты",
  footer_made: "Сделано с заботой для мастеров по всему миру."
};